export const POPULAR_SEARCH_QUERY_OPERATION_NAME = 'KnowledgeDiscoveryPopularSearchQuery';

export const PopularSearchQuery: "\n\tquery KnowledgeDiscoveryPopularSearchQuery($cloudId: String!, $searchQuery: String!) {\n\t\tknowledgeDiscovery @optIn(to: \"KnowledgeDiscovery Get Popular Search Query\") {\n\t\t\tpopularSearchQuery(cloudId: $cloudId, searchQuery: $searchQuery) {\n\t\t\t\t__typename\n\t\t\t\t... on KnowledgeDiscoveryPopularSearchQuery {\n        \tisPopular\n\t\t\t\t}\n\t\t\t\t... on QueryError {\n\t\t\t\t\tmessage\n\t\t\t\t\textensions {\n\t\t\t\t\t\terrorType\n\t\t\t\t\t\tstatusCode\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n" = `
	query ${POPULAR_SEARCH_QUERY_OPERATION_NAME}($cloudId: String!, $searchQuery: String!) {
		knowledgeDiscovery @optIn(to: "KnowledgeDiscovery Get Popular Search Query") {
			popularSearchQuery(cloudId: $cloudId, searchQuery: $searchQuery) {
				__typename
				... on KnowledgeDiscoveryPopularSearchQuery {
        	isPopular
				}
				... on QueryError {
					message
					extensions {
						errorType
						statusCode
					}
				}
			}
		}
	}
`;
